import { NgModule } from "@angular/core";
import { SigoVehiculoModule } from "./vehiculos-sigo/sigo-vehiculo.module";
import { CasillaModule } from "./casilla-electronica/casilla.module";
import { AutorizacionesModule } from "./autorizaciones/autorizaciones.module";

@NgModule({
  declarations: [],
  imports: [SigoVehiculoModule, CasillaModule, AutorizacionesModule],
  exports: [SigoVehiculoModule, CasillaModule, AutorizacionesModule],
  providers: [],
})
export class TransversalModule {}
